<template>
  <div class="about4">
    <div>本廟為達成設立宗旨，經常辦理下列項目：</div>
    <div>
      1.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >宣揚文衡聖地主神聖蹟，已端正宗教信仰。
    </div>
    <div>
      2.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >舉辦道教傳統科儀齋醮慶典道場法會。
    </div>
    <div>
      3.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >倡導倫理道德，匡正社會風氣。
    </div>
    <div>
      4.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >維護，管理所屬財物。
    </div>
    <div>
      5.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >興辦社會救濟，社會公益慈善事業。
    </div>
    <div>
      6.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >敦睦信徒及信眾情誼，培養守望互助精神。
    </div>
    <div>
      7.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >協助推行政令，促進社會祥和。
    </div>
    <div>
      8.
      <span class="Apple-tab-span" style="white-space:pre"></span
      >其他有關應辦事項。
    </div>
    <div>&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'About4',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.about4 img {
  width: 100%;
}
</style>
